import React, { useState, useContext, useEffect } from "react";
import AuthContext from "../../context/auth/authContext";
import SubscriptionsContext from "../../context/subscriptions/subscriptionsContext";
import ClientsContext from "../../context/clients/clientsContext";
import AlertContext from "../../context/alert/alertContext";
import Alerts from "../../components/layout/Alerts";
import Switch from "react-switch";
import { Dropdown } from "react-bootstrap";

const SubscriptionForm = () => {
  const subscriptionsContext = useContext(SubscriptionsContext);
  const clientsContext = useContext(ClientsContext);
  const authContext = useContext(AuthContext);
  const alertContext = useContext(AlertContext);
  const { setAlert } = alertContext;

  const currentUser = authContext.user.email;

  const {
    addSubscription,
    current,
    clearCurrent,
    updateSubscription,
    getDropdowns
  } = subscriptionsContext;

  useEffect(() => {
    if (current != null) {
      setSubscription(current);
    } else {
      setSubscription({
        appName: "",
        clientName: "",
        licensed: false,
        paidCurrent: false,
        cutOffDate: "",
        terms: "",
        gracePeriodDays: "",
        lastUpdatedBy: "",
        message: ""
      });
    }
  }, [subscriptionsContext, current]);

  useEffect(() => {
    getDropdowns();
    // eslint-disable-next-line
  }, []);

  const [subscription, setSubscription] = useState({
    appName: "",
    clientId: "",
    licensed: false,
    paidCurrent: false,
    cutOffDate: new Date(),
    terms: "",
    gracePeriodDays: "",
    message: ""
  });

  const {
    appName,
    licensed,
    paidCurrent,
    cutOffDate,
    terms,
    gracePeriodDays,
    message
  } = subscription;

  const onChange = e => {
    setSubscription({ ...subscription, [e.target.name]: e.target.value });
  };

  const onChangeLicensed = e => {
    setSubscription({ ...subscription, licensed: e });
  };

  const onChangePaidCurrent = e => {
    setSubscription({ ...subscription, paidCurrent: e });
  };

  const onChangeTerms = e => {
    setSubscription({ ...subscription, terms: e });
  };

  const onChangeAppName = e => {
    setSubscription({ ...subscription, appName: e });
  };

  const onSubmit = e => {
    e.preventDefault();
    if (subscription.appName && subscription.appName !== "") {
      if (current === null) {
        //debugger;
        subscription.clientId = clientsContext.current.id;
        subscription.lastUpdatedBy = currentUser;
        addSubscription(subscription);
      } else {
        subscription.lastUpdatedBy = currentUser;
        updateSubscription(subscription);
      }
      clearAll();
    } else {
      setAlert("App Name cannot be blank", "danger");
    }
    //}
  };

  const clearAll = () => {
    clearCurrent();
  };

  const { dropdowns } = subscriptionsContext;

  return (
    <form onSubmit={onSubmit}>
      <h3 className="tex-primary">
        {current ? "Edit Subscription" : "Add Subscription"}
      </h3>
      <Alerts />
      <div className="my-3">
        <Dropdown
          name="appName"
          value={appName}
          onSelect={onChangeAppName}
          style={{ margin: "auto" }}
        >
          <Dropdown.Toggle
            variant="success"
            id="dropdown-basic"
            style={{ width: "100%" }}
          >
            {appName ? appName : "Application Name"}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {dropdowns &&
              dropdowns
                .filter(d => d.control === "appName")
                .map(app => (
                  <Dropdown.Item key={app.id} eventKey={app.storedValue}>
                    {app.displayValue}
                  </Dropdown.Item>
                ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <div className="grid-2">
        <label className="container">
          <span className="switchLabel">Licensed: </span>
          <Switch onChange={onChangeLicensed} checked={licensed} />
        </label>
        <label className="container">
          <span className="switchLabel">Paid Current: </span>
          <Switch onChange={onChangePaidCurrent} checked={paidCurrent} />
        </label>
      </div>

      <div className="grid-3">
        <Dropdown
          name="terms"
          value={terms}
          onSelect={onChangeTerms}
          style={{ margin: "auto" }}
          placeholder="Application Name"
        >
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            {terms ? terms : "Terms"}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {dropdowns &&
              dropdowns
                .filter(d => d.control === "terms")
                .map(term => (
                  <Dropdown.Item key={term.id} eventKey={term.storedValue}>
                    {term.displayValue}
                  </Dropdown.Item>
                ))}
          </Dropdown.Menu>
        </Dropdown>

        <input
          type="date"
          name="cutOffDate"
          value={cutOffDate}
          onChange={onChange}
          placeholder="Terms"
        />

        <input
          type="text"
          name="gracePeriodDays"
          value={gracePeriodDays}
          onChange={onChange}
          placeholder="Grace Days"
        />
      </div>

      <textarea
        name="message"
        cols="30"
        rows="3"
        value={message ? message : ""}
        onChange={onChange}
        placeholder="Message / Notes - this will go out on all api calls"
        maxLength="254"
      ></textarea>

      {/* <input type='text' name='terms' value={terms} onChange={onChange} /> */}

      <div>
        <input
          type="submit"
          value={current ? "Update Subscription" : "Add Subscription"}
          className="btn btn-primary btn-block"
        />
      </div>

      {current && (
        <div>
          <button className="btn btn-light btn-block" onClick={clearAll}>
            Clear
          </button>
        </div>
      )}
    </form>
  );
};

export default SubscriptionForm;
